import { Injectable } from "@angular/core";
import { HTTPService } from "app/shared/services/http.service";
import { ManagedClient } from "app/shared/models/managed-client";

@Injectable()
export class MessageTemplateService {

    constructor(private dac$http:HTTPService) {
    }

    /**
     * Return the message for a given client.
     * @param client 
     */
    public getMessageForClient(client:ManagedClient) {

        return this.dac$http.get("/message-templates/", {clientId: client.id}).then(response => {
            let template = response.json() || {};
            return template;
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/admin/services/message-template.service.ts